module.exports = __webpack_public_path__ + "static/Soukhya_SK-567e500cbc46d602fd55bd91da0fe69c.jpeg";